/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=65022db6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=65022db6&lang=less"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__